export default "__VITE_PUBLIC_ASSET__35d7fe0a__"